import React from 'react';
import { forWho } from '../data/content';
export function ForWho() {
  return <section className="w-full bg-cream-deep px-5 py-14 sm:px-8 sm:py-20" data-id="element-92" data-mp="27loyp8oiv96i">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="27jvs1tdwsoyi">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-plum sm:text-3xl" data-id="element-94" data-mp="2ckrsfwz1xsz6">
          Este método es para quién...
        </h2>
        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-95" data-mp="2hdulm3zx30eu">
          {forWho.map((item, index) => <li key={item.text} className={`flex items-start gap-3 rounded-xl border-l-4 border-terracotta bg-cream px-5 py-4 shadow-sm ${index === forWho.length - 1 && forWho.length % 2 === 1 ? 'sm:col-span-2' : ''}`} data-id="element-96" data-mp="2md7asve9gjkl" data-mpi={index}>
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-97" data-mp="308jevteb3me6">
                {item.emoji}
              </span>
              <span className="font-sans text-sm leading-relaxed text-plum sm:text-base" data-id="element-98" data-mp="15wl3bksiyef4">
                {item.text}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}